module.exports = __webpack_public_path__ + "img/ico_quest.69c95a5f.svg";